// import moment from "moment-timezone";
import * as moment from "moment";
import monentTz from "moment-timezone";

export function convertISODateToDate(isoDate: string): Date | "" {
  // 2018-10-18T04:24:00.000Z
  if (!isoDate) {
    return "";
  }
  const formatData = 'YYYY-MM-DDTHH:mm:ss.SSS';
  const momentDateFromBase = moment.parseZone(isoDate);
  const date = moment(momentDateFromBase.format(formatData));

  return new Date(date.toDate());
}

export function convertTimestampToString(timestamp: number): string {
  // 22/05/2018 20:11
  if (!timestamp) {
    return "";
  }
  const dateStringWithTimeZone: string = monentTz(timestamp)
    .tz("Asia/Bangkok")
    .format("DD/MM/YYYY HH:mm");
  return dateStringWithTimeZone;
}



// WEBPACK FOOTER //
// /app/src/app/shared/utilities.functions.ts